import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Faq.css"; // keep your original FAQ styles

const faqItems = [
  {
    question: "What is ABCD International Family?",
    answer:
      "A global training and coaching organization with 11 world records, dedicated to reducing failure and bringing success and happiness into people’s lives.",
  },
  {
    question: "Who can join your programs?",
    answer:
      "Professionals, entrepreneurs, authors, corporates, and institutions — anyone seeking growth, success, and transformation.",
  },
  {
    question:
      "What services do you provide?",
    answer:
      "Corporate training, business coaching, author coaching & publishing, webinars, masterclasses, and global summits.",
  },
  {
    question: "How do you conduct your programs?",
    answer:
      "Both online (webinars, coaching) and offline (workshops, summits, events).",
  },
  {
    question: "How do you conduct your programs?",
    answer:
      "Through our website or by contacting us at +91 9322503465 / +91 9324553209.",
  },
];

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(0); // first item open by default

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const toggleFaq = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="faq section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Frequently Asked Questions</h2>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div
            className="col-lg-10 mt-4"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="faq-container">
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${
                    activeIndex === index ? "faq-active" : ""
                  }`}
                >
                  <h3 onClick={() => toggleFaq(index)}>
                    {item.question}
                  </h3>
                  <div
                    className="faq-content"
                    style={{
                      display: activeIndex === index ? "block" : "none",
                    }}
                  >
                    <p>{item.answer}</p>
                  </div>
                  <i
                    className="faq-toggle bi bi-chevron-right"
                    onClick={() => toggleFaq(index)}
                  ></i>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
